import { DATA_LAYER_SCOPES } from "seneca-common/features/analytics";
import { pushGlobalValuesToDataLayer } from "seneca-common/features/analytics/gtm";
import { ParentType } from "seneca-common/features/parents/features/parent/service/hooks/types";

export default function parentAnalytics(data?: ParentType) {
  if (!data) return;

  const payload = prepareData(data);
  pushGlobalValuesToDataLayer({ [DATA_LAYER_SCOPES.PARENT]: payload });
}

function prepareData(data: ParentType) {
  const { code, children } = data;
  return { code, numberOfChildren: children.length };
}
